import { useNavigate, useLocation } from 'react-router-dom';

const MENU_ITEMS = [
  { path: '/mypage', label: '프로필' },
  { path: '/mypage/scrapmanage', label: '스크랩 관리' },
  { path: '/mypage/postingmanage', label: '구인게시글 관리', matchPaths: ['/mypage/postingmanage', '/mypage/postingedit', '/mypage/applicantmanage', '/mypage/applicantresume', '/mypage/talent'] },
  { path: '/mypage/resumemanage', label: '이력서 관리', matchPaths: ['/mypage/resumemanage', '/mypage/resumeedit', '/mypage/resumeview', '/mypage/applicationmanage', '/mypage/applications', '/mypage/alerts'] },
  { path: '/mypage/profilepage', label: '프로필페이지 관리' },
  { path: '/mypage/retreatpostingmanage', label: '수련회게시글 관리' },
  { path: '/mypage/aisermonmanage', label: 'AI설교지원 관리' },
  // { path: '/mypage/servicemanage', label: '서비스 관리' },
] as const;

export default function MypageMenu() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (item: (typeof MENU_ITEMS)[number]) => {
    if (item.path === '/mypage') {
      return location.pathname === '/mypage' || location.pathname === '/mypage/';
    }
    const paths = 'matchPaths' in item ? item.matchPaths : [item.path];
    return paths.some((path) => location.pathname === path || location.pathname.startsWith(`${path}/`));
  };

  return (
    <aside className="subpage__menu">
      <h2 className="subpage__menu__title">마이페이지</h2>
      <nav className="sidebar-nav">
        {MENU_ITEMS.map((item) => (
          <div
            key={item.path}
            role="button"
            tabIndex={0}
            onClick={() => {
              navigate(item.path);
              window.scrollTo(0, 0);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate(item.path);
                window.scrollTo(0, 0);
              }
            }}
            className={`sidebar-link ${isActive(item) ? 'is-active' : ''}`}
          >
            <span className="dot" />
            {item.label}
          </div>
        ))}
      </nav>
    </aside>
  );
}
